module.exports = __webpack_public_path__ + "img/down.8dffb074.svg";